<template>
  <div
    class="border mt-1 rounded max-h-[90vh] p-2 text-xl min-w-[22.7%] mx-1 text-left px-4 py-3"
  >
    <h1>
      <span
        :class="[
          totalAmount ? 'text-[#009285]' : '',
          totalCosts ? 'text-[#B45A5A]' : '',
          totalServices ? 'text-[#B49B5A]' : '',
          schedules ? 'text-[#004b92]' : '',
        ]"
      >
        {{ props.value }}
      </span>
      <br />
      <div class="flex flex-col">
        <span class="text-gray-500 text-base">
          {{ props.label }}
        </span>
        <small class="text-gray-400 text-xs" v-if="currentMount">
          neste mês: {{ currentMount }}
        </small>
      </div>
    </h1>
  </div>
</template>

<script setup>
const props = defineProps({
  label: String,
  value: [String, Number],
  totalAmount: { Boolean, default: false },
  totalCosts: { Boolean, default: false },
  totalServices: { Boolean, default: false },
  schedules: { Boolean, default: false },

  currentMount: { String, required: false }
})
</script>
